<template>
    <div>
        <!-- tabla -->
        <v-card>
            <v-card-text>
                <v-simple-table>
                    <thead>
                        <tr>
                            <th v-for="columna in ajustes.columnas" :key="columna.key">
                                <v-layout align-content-space-between>
                                    <span v-if="columna.visible">
                                        <v-flex>{{columna.titulo}}</v-flex>
                                        <v-flex class="text-right">
                                            <v-btn text icon @click="ordenar(columna)">
                                                <span v-if="columna.filtro.orden == 'ASC'">
                                                    <v-icon color="blue darken-4">keyboard_arrow_up</v-icon>
                                                </span>
                                                <span v-if="columna.filtro.orden == 'DESC'">
                                                    <v-icon color="red darken-4">keyboard_arrow_down</v-icon>
                                                </span>
                                            </v-btn>
                                        </v-flex>
                                    </span>
                                    
                                </v-layout>
                            </th>
                            <th v-for="accion in ajustes.acciones" :key="accion.key">
                                {{accion.titulo}}
                            </th>
                            
                        </tr>
                        <!-- <tr>
                            <th v-for="column in settings.columns" :key="column.key">
                                <span v-if="column.filter.visible == true && column.visible">
                                    <v-text-field type="text" color="blue darken-3" v-model="filters.values[column.key]"></v-text-field>
                                </span>
                            </th>
                            <th v-for="action in settings.actions" :key="action.key"></th>
                        </tr> -->
                    </thead>
                    <tbody>
                        <!-- por cada item en la lista -->
                        <tr v-for="item in lista" :key="item.id">
                            <!-- por cada columna de las settings -->
                            <td v-for="columna in ajustes.columnas" :key="columna.key">
                                <span v-if="columna.visible">
                                    <span v-if="columna.tipo == 'fecha'">{{obtenerValor(item,columna.path)}}</span>
                                    <span v-if="columna.tipo == 'texto'">{{obtenerValor(item,columna.path)}}</span>
                                    <span v-if="columna.tipo == 'numero'">{{obtenerValor(item,columna.path)}}</span>
                                </span>
                            </td>

                            <!-- acciones -->
                            <td v-for="accion in ajustes.acciones" :key="accion.key">
                                <span v-if="accion.visible == true">
                                    <!-- editar -->
                                    <v-btn v-if="accion.key == 'editar'" color="blue darken-3" fab small dark @click="editar(item)"><v-icon>edit</v-icon></v-btn>
                                    <v-btn v-if="accion.key == 'disabled'" color="red darken-4" fab small dark><v-icon>block</v-icon></v-btn>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-card-text>
        </v-card>
        <!-- tabla -->
    </div>
</template>
<script>
export default {
    props:['ajustes'],
    data: ()=>({
        filtro:{
            values:{}
        },
        lista:[]
    }),
    created() {
        Event.$on('actualizar_lista',(lista)=>{
            //console.log('recibiendo lista',lista);
            // console.log('what the fuck?');
            this.lista = lista;
        });
    },
    mounted(){
        console.log(this.lista,this.ajustes);
    },
    methods:{
        ordenar(columna){
            console.log(columna);
        },

        editar(item){
            this.$emit('editar',item);
        },

        //recibe el item actual y el path de la columna donde se encuentra el valor a obtener
        obtenerValor(item,path){
            //console.log('item y path',item,path)
            let value = item;
            let stack = path.split('.');
            let history = [];
            let peek;

            while (value[stack[0]]) {
                if (peek) {
                    history.push(peek);
                }
                peek = stack.shift();
                value = value[peek];
            }

            if (stack.length > 0) {
                history.push(peek);
                value = "";
            }

            return value;
        },
    }
}
</script>